// Occurrence overrides keep their own time; series may store it in recurrence.
export function getEventTime(event = {}) {
  const direct = typeof event.time === 'string' ? event.time.trim() : '';
  const recurring = typeof event.recurrence?.time === 'string' ? event.recurrence.time.trim() : '';
  return direct || recurring || '';
}
